var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBankTransfer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.01 1.782c.177 0 .348.054.492.155l6.22 4.354a.857.857 0 0 1 0 1.404l-6.22 4.354a.86.86 0 0 1-.387.149l-.102.006a.856.856 0 0 1-.86-.857V9.564h-8.57a2.571 2.571 0 1 1 0-5.142h8.57V2.638c0-.44.332-.801.758-.85zM9.968 12.074l-.101-.006-.102.006a.85.85 0 0 0-.388.149l-6.22 4.354a.86.86 0 0 0 0 1.404l6.22 4.354c.144.1.316.155.492.155l.1-.006a.857.857 0 0 0 .757-.851V19.85h8.572a2.571 2.571 0 1 0 0-5.143h-8.572v-1.782a.86.86 0 0 0-.758-.851m-4.824 5.205 3.868-2.707v1.85h10.286a.857.857 0 0 1 0 1.714H9.01v1.85zM15.868 6.136v-1.85l3.868 2.707-3.868 2.708V7.85H5.582a.857.857 0 0 1 0-1.714z",
  clipRule: "evenodd"
})));
export default SvgBankTransfer;